// extracted by mini-css-extract-plugin
export default {"toggleContainer":"WeekdayToggle_toggleContainer__Z2aRE","active":"WeekdayToggle_active__pvkBs"};